import styled from 'styled-components';

import SEGMENTATION_LUNG_TYPES from '../../data/segmentation-lung-types';

import { colors } from '../../ui/variables';

const EXAM_IMAGE_SIZE = 512;

export const SegmentationCanvasStyle = styled.div`
  height: ${EXAM_IMAGE_SIZE}px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: ${EXAM_IMAGE_SIZE}px;

  .segmentation-list-container,
  .segmentation-button {
    height: ${EXAM_IMAGE_SIZE}px;
    left: 0;
    position: absolute;
    top: 0;
    width: ${EXAM_IMAGE_SIZE}px;
  }

  .segmentation-list-container {
    circle {
      &.type-${SEGMENTATION_LUNG_TYPES?.left?.key} {
        fill: ${colors.softOrange};
      }

      &.type-${SEGMENTATION_LUNG_TYPES?.right?.key} {
        fill: ${colors.softPink};
      }
    }
  }
`;
